

export default class storyboardRoleService {

  static canManageStoryboard(storyboard) {
    return storyboard && storyboard.role === 'owner';
  }

  static canEditStoryboard(storyboard) {
    if(!storyboard) {
      return false;
    }
    
    return storyboard.role === 'owner' || storyboard.role === 'editor';
  }
}